import React from 'react'
import {
    AllEvents,
    BreakingNewsCard,
    createCardClickedEvent,
    useFeature,
} from '@news-mono/web-common'
import {
    MiniWaFootyLivesHereIcon,
    StyledBackgroundImage,
    StyledFootyLivesHerePromoStrapContainer,
    StyledFootyLivesHereText,
    StyledInnerContainer,
    StyledInnerTextContainer,
} from './FootyLivesHerePromoStrap.styled'
import { useViewport } from '../../__helpers/use-viewport'

export interface FootyLivesHerePromoStrapProps {
    bannerLink: string
    text: string
    onEvent: (event: AllEvents) => void
    impressionRef: React.RefObject<HTMLDivElement>
}

export const FootyLivesHerePromoStrap = ({
    bannerLink,
    text,
    onEvent,
    impressionRef,
}: FootyLivesHerePromoStrapProps) => {
    const { isMobile } = useViewport()
    const backgroundImg = require('./assets/background-image.jpg')
    const hideOnMobileAndApp = useFeature(
        'hide-mobile-breaking-news-banner',
        true,
    )

    const item: BreakingNewsCard = {
        shortHeadline: 'FOOTY LIVES HERE',
        link: bannerLink,
        cardType: 'breaking-news',
        listId: 'footy-lives-here-promo-strap',
    }
    const linkClicked = () => {
        onEvent(
            createCardClickedEvent(
                onEvent,
                item,
                'FootyLivesHerePromoStrap',
                'FootyLivesHerePromoStrap',
                1,
            ),
        )
    }

    // I want to split the 'text' on the 'FREE' word and wrap it in a span with different styling
    const highlightedText = text
        .split(/(FREE)/)
        .map((part, index) =>
            part === 'FREE' ? <span key={index}>{part}</span> : part,
        )

    return (
        <div ref={impressionRef}>
            <StyledFootyLivesHerePromoStrapContainer
                hideOnMobileAndApp={hideOnMobileAndApp}
                href={bannerLink}
                onClick={linkClicked}
            >
                <StyledBackgroundImage
                    src={backgroundImg}
                    alt="background image"
                />
                <StyledInnerContainer>
                    <MiniWaFootyLivesHereIcon />
                    <StyledInnerTextContainer>
                        <StyledFootyLivesHereText>
                            {highlightedText}
                        </StyledFootyLivesHereText>
                    </StyledInnerTextContainer>
                    {!isMobile && <MiniWaFootyLivesHereIcon />}
                </StyledInnerContainer>
            </StyledFootyLivesHerePromoStrapContainer>
        </div>
    )
}
